module.exports = __webpack_public_path__ + "img/Layer1op.5e7e68eb.jpg";